import { j as t } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as d, useState as a } from "react";
import { T as i } from "./TextField-L5Yijkyt.mjs";
const n = d(({ ...o }, e) => {
  const [s, r] = a(!1);
  return /* @__PURE__ */ t.jsxs("div", { style: { position: "relative", boxSizing: "content-box" }, children: [
    /* @__PURE__ */ t.jsx(i, { type: s ? "text" : "password", ref: e, ...o }),
    /* @__PURE__ */ t.jsx(
      "button",
      {
        type: "button",
        onClick: () => r(!s),
        className: `rds-password-textfield-button ${s ? "rds-password-textfield-button--hide" : "rds-password-textfield-button--show"}`,
        children: /* @__PURE__ */ t.jsx("span", { className: "sr-only", children: s ? "Skjul passord" : "Vis passord" })
      }
    )
  ] });
});
n.displayName = "PasswordTextField";
export {
  n as P
};
